<!--
  Logout.svelte — Dedicated sign-out route (`/logout`).

  Gives sign-out a URL other apps and the profile card can link to, and makes
  it a real sign-out rather than a local one: the current JWT is revoked
  server-side before any client state is torn down, so the token cannot be
  replayed until it happens to expire.

  Revocation is best-effort. A network failure, or a token the server has
  already blocklisted, must not strand the user on this page holding
  credentials — so the local teardown runs either way.

  The public app shell exempts this path from its "authenticated users belong
  in /Manage/" guard; without that exemption the guard would bounce the user
  away before this component ever mounted.
-->
<script lang="ts">
	import { onMount } from 'svelte';
	import { Spinner } from 'flowbite-svelte';
	import { logout } from '../../Auth';
	import { serverLogout } from '../../AppNetwork';
	import { t } from '../../i18n';

	onMount(async () => {
		/** Revoke the session server-side; failure here must not block sign-out. */
		try {
			await serverLogout();
		} catch {
			/* Already invalid, or the server is unreachable — clear locally regardless. */
		}

		/* Stops the refresh timer, clears the token, and lands on /login. */
		logout();
	});
</script>

<div
	class="flex min-h-screen flex-col items-center justify-center gap-3 bg-white text-gray-500 dark:bg-gray-900 dark:text-gray-400"
>
	<Spinner size="8" />
	<p>{$t("Signing you out…")}</p>
</div>
